import { Fragment, type FunctionComponent, useCallback, useRef, useState } from "react";
import PortalPopup from "@delivery-management/PortalPopup.tsx";
import StatusFilter from "@delivery-management/DeliveyMangement/Popup/StatusFilter.tsx";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import SearchID from "@delivery-management/DeliveyMangement/Popup/SearchID.tsx";
import SearchPaymentMethod from "@delivery-management/DeliveyMangement/Popup/SearchPaymentMethod.tsx";
import SearchTime from "@delivery-management/DeliveyMangement/Popup/SearchTime.tsx";
import SearchPlatform from "@delivery-management/DeliveyMangement/Popup/SearchPlatform.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";
import dayjs from "dayjs";
import DeliveryListOrderRow from "@delivery-management/DeliveyMangement/DeliveryListOrderRow.tsx";
import {
  clearAllFilter,
  type FilterDelivery,
  filtersDelivery,
  isCurrentOrderD,
  isReachingEndOnlineOrders,
  isValidatingOnlineOrders,
  onlineOrders1,
  setFiltersDelivery,
  setIsValidatingOnlineOrders,
  setOnlineOrdersPage
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { Virtuoso } from "react-virtuoso";
import clsx from "clsx";
import SearchCustomer from "@delivery-management/DeliveyMangement/Popup/SearchCustomer.tsx";
import { onlineProviders } from "@/react/OnlineOrderSettingView/OnlineProviderSettingView.logic.tsx";
import _ from "lodash";
import { LL2 } from "@/react/core/I18nBackend.tsx";

export type ViewTableType = {
  className?: string;
};

const ViewTable: FunctionComponent<ViewTableType> = ({ className = "" }) => {
  const leftPathRef = useRef<any>(null)

  const [isOpenStatusFilterPopup, setIsOpenStatusFilterPopup] = useState(false);
  const [isOpenSearchIdPopup, setIsOpenSearchIdPopup] = useState(false);
  const [isOpenSearchCustomerPopup, setIsOpenSearchCustomerPopup] = useState(false);
  const [isOpenPaymentMethodPopup, setIsOpenPaymentMethodPopup] = useState(false);
  const [isOpenSearchTimePopup, setIsOpenSearchTimePopup] = useState(false);
  const [isOpenSearchPlatformPopup, setIsOpenSearchPlatformPopup] = useState(false);

  const openSearchTimePopup = useCallback(() => {
    setIsOpenSearchTimePopup(true)
  }, [])
  const closeSearchTimePopup = useCallback(() => {
    setIsOpenSearchTimePopup(false)
  }, [])
  const openStatusFilterPopup = useCallback(() => {
    setIsOpenStatusFilterPopup(true)
  }, [])
  const closeStatusFilterPopup = useCallback(() => {
    setIsOpenStatusFilterPopup(false)
  }, [])
  const openSearchIdPopup = useCallback(() => {
    setIsOpenSearchIdPopup(true)
  }, [])
  const closeSearchIdPopup = useCallback(() => {
    setIsOpenSearchIdPopup(false)
  }, [])
  const openPaymentMethodPopup = useCallback(() => {
    setIsOpenPaymentMethodPopup(true)
  }, [])
  const closePaymentMethodPopup = useCallback(() => {
    setIsOpenPaymentMethodPopup(false)
  }, [])
  const openSearchPlatformPopup = useCallback(() => {
    setIsOpenSearchPlatformPopup(true)
  }, [])
  const closeSearchPlatformPopup = useCallback(() => {
    setIsOpenSearchPlatformPopup(false)
  }, [])
  const openCustomerInfoPopup = useCallback(() => {
    setIsOpenSearchCustomerPopup(true)
  }, [])
  const closeCustomerInfoPopup = useCallback(() => {
    setIsOpenSearchCustomerPopup(false)
  }, [])

  const onClickScrollToTop = useCallback(
    () =>
      leftPathRef.current?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      }),
    []
  )

  const isFiltering = Object.values(filtersDelivery()).some(value => {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "object" && value !== null) return Object.keys(value).length > 0;
    return Boolean(value);
  });

  const filterITem = ({ label, value, onClear, show }: { label: string, value: any, onClear: () => void, show: boolean}) => {

    return show ? (
      <div key={label} className="rounded bg-white p-1 flex items-center gap-1 text-gray-900">
        <div className="flex items-start gap-1">
          <span className="Tablet_768:text-3xs">{label}:</span>
          <span className="Tablet_768:text-3xs">{value}</span>
        </div>
        <div className="w-4 h-4 overflow-hidden shrink-0 cursor-pointer" onClick={onClear}>
          <img className="w-full h-full object-cover" alt="clear"
               src="/icondelete-fillter-icon@2x.png"/>
        </div>
      </div>
    ) : null
  }

  return (
    <>
      <div
        className={`self-stretch flex-1 overflow-y-auto flex flex-col items-start justify-start z-[1] text-left text-[14px] text-[#fff] font-[Mulish] ${className}`}
      >
        <div
          className="no-scrollbar self-stretch overflow-y-auto flex-1 flex flex-col items-start justify-start !bg-[url('/-inventory-plugin@3x.png')] bg-cover bg-no-repeat bg-[top] z-[0] text-center text-sm text-white-solid-white-100-ffffff font-mulish-button-name-bold">
          <Virtuoso
            ref={leftPathRef}
            style={{ height: "100%", width: "100%" }}
            className="no-scrollbar"
            data={onlineOrders1()}
            endReached={() => {
              if (!isReachingEndOnlineOrders() && !isValidatingOnlineOrders()) {
                console.log("increase size...", onlineOrders1().length);
                setIsValidatingOnlineOrders(true);
                setOnlineOrdersPage((prev) => prev + 1);
              }
            }}
            itemContent={(index, order) => (
              <div
                className={clsx("after:absolute after:top-[0px] after:left-[0px] after:bottom-[0px] after:right-[0px] after:border-red-500 after:pointer-events-none border-b-[1px] border-b-[#364150] relative self-stretch relative shrink-0 grid grid-cols-[minmax(auto,58px)_minmax(auto,82px)_2fr_minmax(auto,138px)_minmax(auto,172px)_2fr_56px] [grid-row-gap:0px] [grid-column-gap:0px] sm:grid sm:grid-cols-[minmax(auto,58px)_minmax(auto,76px)_2fr_minmax(auto,130px)_minmax(auto,132px)_2fr_48px] sm:[grid-row-gap:0px] sm:[grid-column-gap:0px] mq768:grid mq600:grid mq600:grid-cols-[minmax(auto,58px)_minmax(auto,65px)_2fr_minmax(auto,116px)_1fr_2fr_40px] mq600:[grid-row-gap:0px] mq600:[grid-column-gap:0px] h.414:grid",
                  isCurrentOrderD(order._id) ? "after:border-[2px]" : "after:border-none"
                )}
              >
                <DeliveryListOrderRow isSelected={isCurrentOrderD(order._id)} order={order} key={order?._id}
                                      _id={order?._id} isEven={index % 2 !== 0}/>
              </div>
            )}
            components={{
              Header: () => (
                <div
                  className="self-stretch relative shrink-0 grid grid-cols-[minmax(auto,58px)_minmax(auto,82px)_2fr_minmax(auto,138px)_minmax(auto,172px)_2fr_56px] [grid-row-gap:0px] [grid-column-gap:0px] sm:grid-cols-[minmax(auto,58px)_minmax(auto,76px)_2fr_minmax(auto,130px)_minmax(auto,132px)_2fr_48px] sm:[grid-row-gap:0px] sm:[grid-column-gap:0px] mq768:grid mq600:grid mq600:grid-cols-[minmax(auto,58px)_minmax(auto,65px)_2fr_minmax(auto,116px)_1fr_2fr_40px] mq600:[grid-row-gap:0px] mq600:[grid-column-gap:0px] h.414:grid">
                  <div
                    onClick={openSearchIdPopup}
                    className="bg-black-solid-black-700-364150 h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 box-border gap-[2px] min-w-[40px] relative sm:relative">
                    <img
                      className="relative w-4 h-4 object-cover sm:hidden"
                      alt=""
                      src="/iconsearch-icon-white@2x.png"
                    />
                    <b className="flex-1 relative Tablet_768:text-xs underline">ID</b>
                  </div>
                  <div
                    onClick={openSearchTimePopup}
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff sm:relative"
                    ref={makeRipple}
                  >
                    <img
                      className="w-4 relative h-4 object-cover sm:hidden"
                      alt=""
                      src="/iconsearch-icon-white@2x.png"
                    />
                    <b className="relative Tablet_768:text-xs underline">{LL0().payment.time()}</b>
                  </div>
                  <div
                    ref={makeRipple}
                    onClick={openCustomerInfoPopup}
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff sm:relative"
                  >
                    <img
                      className="w-4 relative h-4 object-cover sm:hidden"
                      alt=""
                      src="/order-history-iconsearch-icon11@2x.png"
                    />
                    <b className="relative Tablet_768:text-xs underline">{LL0().dashboard.customerInfo()}</b>
                  </div>
                  <div
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff sm:relative"
                  >
                    <b className="relative Tablet_768:text-xs">{LL0().orderHistory.amount()}</b>
                  </div>
                  <div
                    onClick={openSearchPlatformPopup}
                    ref={makeRipple}
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff sm:relative">
                    <img
                      className="w-4 relative h-4 object-cover sm:hidden"
                      alt=""
                      src="/iconsearch-icon-white@2x.png"
                    />
                    <b className="relative Tablet_768:text-xs underline">{LL0().deliveryManagement.platform()}</b>
                  </div>
                  <div
                    onClick={openStatusFilterPopup}
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-start py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff"
                    ref={makeRipple}
                  >
                    <img
                      className="w-4 relative h-4 object-cover sm:hidden"
                      alt=""
                      src="/iconsearch-icon-white@2x.png"
                    />
                    <b className="relative Tablet_768:text-xs underline">{LL0().settings.emailReport.emailHistoryDialog.status()}</b>
                  </div>
                  <div
                    className="bg-black-solid-black-700-364150 box-border h-[38px] flex flex-row items-center justify-center py-2.5 px-1.5 gap-[2px] cursor-pointer relative border-l-[1px] border-solid border-white-solid-white-100-ffffff sm:relative Tablet_768:relative Tablet_600:relative Mobile_480:relative mq320:relative"
                    ref={makeRipple}
                  >
                    <b className="relative Tablet_768:text-xs"></b>
                  </div>
                  {isFiltering && <div
                    className="relative bg-gray-solid-gray-300-dbdbdb flex items-center justify-between py-2 px-2.5 col-span-full text-xs Tablet_768:relative">
                    <img className="w-4 h-4 object-cover absolute right-2" alt="clear"
                         src="/icondelete-fillter-icon@2x.png" onClick={clearAllFilter}/>
                    <div className="flex flex-wrap items-center gap-3 px-2.5">
                      <b
                        className="Tablet_768:text-3xs text-red-solid-red-660-8f181d">{LL0().orderHistory.filter()}:</b>
                      {["creationDate", "searchCustomer", "searchId", "time", "statusUser", "providers"].map(filter => {
                          const value = filtersDelivery()[filter as keyof FilterDelivery];
                          let displayValue = "";
                          if (!value) return null;

                          switch (filter) {
                            case "creationDate":
                              displayValue = dayjs.unix(value as number).format(LL2().dates.dateFormat());
                              break;
                            case "searchCustomer":
                              displayValue = `${value?.customer?.name || "Unknown"}`;
                              break;
                            case "searchId":
                              displayValue = value as string;
                              break;
                            case "time":
                              displayValue = dayjs.unix(value as number).format("HH:mm");
                              break;
                            case "statuses":
                              displayValue = (value as string[]).map(s => _.get(LL0().delivery.deliveryStatus2, s)?.()).join(", ");
                              break;
                            case "providers":
                              displayValue = (value as string[]).map(p => {
                                if (p === "phone") return "phone";
                                else {
                                  return  onlineProviders().find(o => o._id === p)?.name
                                }
                              }).join(", ");
                              break;
                            default:
                              displayValue = JSON.stringify(value);
                          }
                          return filterITem({
                            label: _.get(LL0().deliveryManagement, filter)?.(),
                            value: displayValue,
                            onClear: () => {
                              if (value) {
                                setFiltersDelivery((prev) => {
                                  const updatedFilters = { ...prev };
                                  delete updatedFilters[filter as keyof typeof prev];
                                  return { ...updatedFilters };
                                });
                              }
                            },
                            show: !!displayValue
                          });
                        }
                      )}
                    </div>
                  </div>}
                </div>
              ),
              Footer: () => (
                <div
                  className="text-white">{!isValidatingOnlineOrders() ? LL0().orderHistory.noOrdersLeft() : (LL0().ui.loading + "...")}</div>
              )
            }}
          />
          <div className="absolute my-0 mx-[!important] bottom-[8px] left-[8px] w-[45px] h-[45px] z-[2] rounded-full"
               onClick={onClickScrollToTop} ref={makeRipple}>
            <img
              className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] max-w-full overflow-hidden max-h-full object-cover"
              alt="" src="/icongo-to-top-float-icon@2x.png"/>
          </div>
        </div>

      </div>
      {isOpenStatusFilterPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenStatusFilterPopup(false)}
        >
          <StatusFilter onClose={() => setIsOpenStatusFilterPopup(false)}/>
        </PortalPopup>
      }
      {isOpenSearchIdPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenSearchIdPopup(false)}
        >
          <SearchID onClose={() => setIsOpenSearchIdPopup(false)}/>
        </PortalPopup>
      }
      {isOpenSearchCustomerPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenSearchCustomerPopup(false)}
        >
          <SearchCustomer onClose={() => setIsOpenSearchCustomerPopup(false)}/>
        </PortalPopup>
      }
      {isOpenPaymentMethodPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenPaymentMethodPopup(false)}
        >
          <SearchPaymentMethod onClose={() => setIsOpenPaymentMethodPopup(false)}/>
        </PortalPopup>
      }
      {isOpenSearchTimePopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenSearchTimePopup(false)}
        >
          <SearchTime onClose={() => setIsOpenSearchTimePopup(false)}/>
        </PortalPopup>
      }
      {isOpenSearchPlatformPopup &&
        <PortalPopup
          overlayColor="rgba(0, 0, 0, 0.2)"
          placement="Centered"
          onOutsideClick={() => setIsOpenSearchPlatformPopup(false)}
        >
          <SearchPlatform onClose={() => setIsOpenSearchPlatformPopup(false)}/>
        </PortalPopup>
      }
    </>
  );
};

export default ViewTable;
